window.AccountManagementAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['AccountManagement']);

    self.activateCarri = function(brandId){
        var deferred = $q.defer();
        var brandServices = $injector.get('brandServices');
        var serviceCode = brandServices.SERVICES.CARRI_RAPID_RESPONSE;
        _protected.request('brands/' + brandId + '/services/'+serviceCode, 'POST', {})
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    }
});
